import Slider from "rc-slider";
import styles from "../ourCars.module.css";
import { RangeFilters, RangeFilterProps } from "../types";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { ACTIVE_PRICE_PATH, RETAIL_PRICE_GBP_PATH, MPH_PATH, TOP_SPEED_PATH, POWER_PATH } from "../ourCars-constants";
import {
  publishBHP,
  publishRRP,
  publishTicketPrice,
  publishTopMPH,
  publishZeroTo60,
} from "../../../../../../redux/features/cars/carsSlice";
import { ActionCreatorWithOptionalPayload } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";

const publishAction: {
  [key: string]: ActionCreatorWithOptionalPayload<
    {
      value: number[];
    },
    string
  >;
} = {
  [ACTIVE_PRICE_PATH]: publishTicketPrice,
  [RETAIL_PRICE_GBP_PATH]: publishRRP,
  [MPH_PATH]: publishTopMPH,
  [TOP_SPEED_PATH]: publishZeroTo60,
  [POWER_PATH]: publishBHP,
};

const stateProp: { [key: string]: keyof RangeFilters } = {
  [ACTIVE_PRICE_PATH]: "ticketPrice",
  [RETAIL_PRICE_GBP_PATH]: "rrp",
  [MPH_PATH]: "topMPH",
  [TOP_SPEED_PATH]: "zeroTo60",
  [POWER_PATH]: "bhp",
};

const RangeFilter = ({ label, initialValue, path, onRangeFilterChange, className, isSmView }: RangeFilterProps) => {
  const [max, setMax] = useState(initialValue[0]);
  useEffect(() => {
    setTimeout(() => setMax(initialValue[1]), 150);
  }, []);
  const dispatch = useAppDispatch();
  let currentValue = useAppSelector(state => state.cars[stateProp[path]]);
  currentValue = currentValue.length === 0 ? initialValue : currentValue;

  const areRangeValuesEqual = (arr1: number[], arr2: number[]) => {
    return arr1[0] === arr2[0] && arr1[1] === arr2[1];
  };

  const onChangeFilter = (value: number[]) => {
    onRangeFilterChange(path, value);
    dispatch(publishAction[path]({ value }));
  };

  return (
    <div className={`text-center ${className} relative top-[-6px]`}>
      <label aria-labelledby={label} className={`${styles.rangeSliderLabel}`}>
        {label}
      </label>
      <Slider
        className={isSmView ? "swiper-no-swiping" : ""}
        range
        min={initialValue[0]}
        max={max}
        defaultValue={initialValue}
        styles={{
          handle: {
            borderColor: "#fff",
            boxShadow: isSmView ? "0 0 10px -1px #000" : "0 0 3px -1px #000",
            zIndex: 0,
            width: isSmView ? 20 : 16,
            height: isSmView ? 20 : 16,
            marginTop: isSmView ? -8 : -5,
          },
          rail: { backgroundColor: "rgb(181, 180, 184)" },
          track: areRangeValuesEqual(initialValue, currentValue)
            ? { backgroundColor: "rgb(181, 180, 184)" }
            : { backgroundColor: "rgb(255, 130, 0)" },
        }}
        dotStyle={{ display: "none" }}
        marks={{
          [currentValue[0]]: Math.floor(currentValue[0]),
          [currentValue[1]]: Math.ceil(currentValue[1]),
        }}
        onChange={onChangeFilter}
        value={currentValue}
      />
    </div>
  );
};

export default RangeFilter;
